import React from 'react'
import { Navigate, Route, Routes as RoutesStack } from 'react-router-dom'
import { Routes } from './routes'
import { AccessControl } from '@/core/utils/access-control'
import { OpsErrorBoundary } from '@/core/components/ops-error-boundary'
import { PageNotFound } from '@/core/components/page-not-found'

const TrackedRoute = ({
  path,
  component: Component,
  roles,
  tiposUsuario,
  title,
  ...otherProps
}) => {
  const renderNoAccess = <Navigate to={Routes.HOME.route} />

  return (
    <Route
      path={path}
      element={
        <OpsErrorBoundary>
          <AccessControl
            allowedRoles={roles}
            allowedUserTypes={tiposUsuario}
            renderNoAccess={renderNoAccess}
          >
            <DocumentTitle title={title}>
              <Component {...otherProps} />
            </DocumentTitle>
          </AccessControl>
        </OpsErrorBoundary>
      }
    />
  )
}

const DocumentTitle = ({ title, children }) => {
  if (title) {
    const currentTitle = document.title
    const split = currentTitle.split('-')
    const titleAux = typeof title === 'function' ? title() : title

    document.title = split[0].trim().concat(' - ').concat(titleAux)
  }
  return children
}

export const Router = props => {
  return (
    <RoutesStack>
      <Route path='/' element={<Navigate to={Routes.HOME.route} />} />
      {Object.keys(Routes)
        .filter(key => {
          if (!Routes[key].component) {
            return false
          }
          if (Routes[key].mobileOnly) {
            return props.mobile
          }
          return true
        })
        .map(key => {
          const {
            route,
            component: Component,
            roles,
            tiposUsuario,
            title
          } = Routes[key]
          return (
            <Route
              key={key}
              path={route}
              element={
                <OpsErrorBoundary>
                  <AccessControl
                    allowedRoles={roles}
                    allowedUserTypes={tiposUsuario}
                    renderNoAccess={<Navigate to={Routes.HOME.route} />}
                  >
                    <DocumentTitle title={title}>
                      <Component {...props} />
                    </DocumentTitle>
                  </AccessControl>
                </OpsErrorBoundary>
              }
            />
          )
        })}
      <Route path='*' element={<PageNotFound />} />
    </RoutesStack>
  )
}

export const PublicRouter = () => (
  <RoutesStack>
    <TrackedRoute component={PageNotFound} />
  </RoutesStack>
)
